<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mr-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Plan
          <v-progress-circular
            v-if="isMasterLoading"
            class="ml-5"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="no_of_dogs"
                outlined
                :loading="isMasterLoading"
                v-model="form.no_of_dogs"
                label="No.Of Dogs *"
                :items="dogCount"
                prepend-inner-icon="mdi-dog"
                clearable
                @input="isBasicPlan()"
                :error-messages="errors.no_of_dogs"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="no_of_walks"
                outlined
                :loading="isMasterLoading"
                v-model="form.no_of_walks"
                label="No.Of Walks *"
                :items="walkCount"
                prepend-inner-icon="mdi-walk"
                @input="isBasicPlan()"
                clearable
                :error-messages="errors.no_of_walks"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref="plan_tier"
                outlined
                :loading="isMasterLoading"
                v-model="form.tier"
                label="Tier *"
                :items="plan_tierItems"
                prepend-inner-icon="mdi-equalizer"
                clearable
                :error-messages="errors.tier"
              ></v-autocomplete>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.original_amount"
                outlined
                label="Original Amount *"
                hint="Strike through Amount"
                @input="calculate('ORIGINAL CHANGE')"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.price_percent"
                outlined
                label="Price %"
                @input="calculate('PRICE PERCENT CHANGE')"
                prepend-inner-icon="mdi-percent"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.discount_percent"
                outlined
                label="Discount %"
                @input="calculate('DISCOUNT PERCENT CHANGE')"
                prepend-inner-icon="mdi-percent"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.calculated_final_amount"
                outlined
                readonly
                :loading="isCalculating"
                label="Calculated Final Amount"
                persistent-hint
                hint="As per Calculation, 1st Dog amount"
                prepend-inner-icon="mdi-calculator"
              ></v-text-field>
            </v-col>
            <template v-if="!is_basic_plan">
              <v-col sm="4">
                <v-text-field
                  v-model="form.second_discount_percent"
                  outlined
                  :loading="isCalculating"
                  label="Second Walk/Dog Discount %"
                  @input="CalculateSecondDiscountAmount()"
                  persistent-hint
                  hint="Applied on 1st Dog amount"
                  prepend-inner-icon="mdi-percent"
                ></v-text-field>
              </v-col>
            </template>
            <v-col sm="4">
              <v-text-field
                v-model="form.final_amount"
                outlined
                :loading="isCalculating"
                label="Final Amount"
                persistent-hint
                :hint="is_basic_plan ? 'Final Amount' : Final_amount_hint()"
                @input="calculate('FINAL AMOUNT CHANGE')"
                prepend-inner-icon="mdi-currency-rupee"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.per_walk_time"
                outlined
                label="Per Walk Time"
                prepend-inner-icon="mdi-timer"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.days"
                outlined
                label="Days"
                @input="calculate('DAY CHANGE')"
                prepend-inner-icon="mdi-calendar-month"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.customer_per_day_charges"
                outlined
                :loading="isCalculating"
                label="Customer Per day Charges"
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="12" class="pb-0">
              <h3 class="primary--text">
                Default Commission
                <span class="caption grey--text">
                  (Pre-fills new Zone Commissions. Payouts use the Zone Commission set for each zone.)
                </span>
              </h3>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.walkie_percent"
                outlined
                label="Pet Walker Percentage"
                @input="CalculateCommission('WALKIE PERCENT CHANGE')"
                :hint="`Pet Walker Commission : ${this.form.walkie_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.franchisee_percent"
                outlined
                label="Franchisee Percentage"
                @input="CalculateCommission('FRANCHISEE PERCENT CHANGE')"
                :hint="`Franchisee Commission : ${this.form.franchisee_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.master_franchisee_percent"
                outlined
                label="Master Franchisee Percentage"
                @input="CalculateCommission('MASTER FRANCHISEE PERCENT CHANGE')"
                :hint="`Master Franchisee Commission : ${this.form.master_franchisee_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.company_percent"
                outlined
                label="Walkie Percentage"
                @input="CalculateCompanyAmount()"
                :hint="`Walkie Commission : ${this.form.company_commission_amount}`"
                persistent-hint
                prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <section>
            <v-row>
              <v-col sm="12">
                <h3 class="primary--text">
                  Benefits
                  <span class="caption grey--text">
                    (Feature points shown in the App &amp; Website — leave empty to show the default points)
                  </span>
                </h3>
              </v-col>
            </v-row>
            <template v-for="(benefit, b) in form.benefits">
              <v-row :key="`benefit-${b}`">
                <v-col sm="11">
                  <v-text-field
                    outlined
                    :value="benefit"
                    @input="updateBenefit(b, $event)"
                    :label="`Benefit Point ${b + 1}`"
                    prepend-inner-icon="mdi-check-decagram"
                    :error-messages="
                      errors[`benefits.${b}`] ? errors[`benefits.${b}`] : ``
                    "
                  ></v-text-field>
                </v-col>
                <v-col sm="1">
                  <v-btn
                    fab
                    class="ml-9"
                    small
                    dark
                    color="red"
                    @click="Remove_Benefit(b)"
                  >
                    <v-icon dark> mdi-close-thick </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col sm="12">
                <v-btn v-can:add="'plans'" small rounded color="primary" @click="Add_Empty_Benefit">
                  Add Benefit
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </section>
          <v-divider class="my-5"> </v-divider>
          <v-btn v-can:edit="'plans'"
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Plan
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "PlanCreatePage",
  data() {
    return {
      form: {
        tier: "",
        price_percent: 100,
        discount_percent: 0,
        walkie_commission_amount: 0,
        franchisee_commission_amount: 0,
        company_commission_amount: 0,
        master_franchisee_commission_amount: 0,
        walkie_percent: 0,
        franchisee_percent: 0,
        master_franchisee_percent: 0,
        company_percent: 100,
        calculated_final_amount: 0,
        customer_per_day_charges: 0,
        days: 0,
        final_amount: 0,
        no_of_dogs: 0,
        no_of_walks: 0,
        original_amount: 0,
        per_walk_time: 0,
        benefits: [],
      },
      dogCount: ["1", "2"],
      walkCount: ["1", "2"],
      plan_tierItems: [],
      isLoading: false,
      isMasterLoading: false,
      isCalculating: false,
      is_basic_plan: true,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    isBasicPlan() {
      let no_of_dogs = this.form.no_of_dogs;
      let no_of_walks = this.form.no_of_walks;
      this.is_basic_plan = true;
      if (no_of_dogs > 1 || no_of_walks > 1) {
        this.is_basic_plan = false;
        this.form.second_discount_percent = null;
        this.form.second_discount_amount = 0;
      }
    },
    Final_amount_hint() {
      let text = "Final Discounted Amount";
      if (this.form.no_of_dogs > 1 && this.form.no_of_walks > 1) {
        text ==
          "1st Dog Fee :" +
            this.form.calculated_final_amount +
            " + Second Dog/walk : " +
            this.form.second_discount_amount;
      }
      return text;
    },
    async getMasters() {
      this.isMasterLoading = true;
      await axios
        .get(`masters?context=plans`)
        .then((masters) => {
          masters = masters.data;
          //Position
          masters.plan_tiers.forEach((plan_tier) => {
            this.plan_tierItems.push({
              id: plan_tier.id,
              text: plan_tier.description,
              value: plan_tier.description,
            });
          });
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isMasterLoading = false;
      this.isBasicPlan();
    },
    calculate(type = "") {
      this.isCalculating = true;
      let original_amount = this.form.original_amount;
      let price_percent = this.form.price_percent;
      let discount_percent = this.form.discount_percent;
      if (original_amount) {
        if (type == "PRICE PERCENT CHANGE" && price_percent) {
          this.form.discount_percent = 100 - parseInt(price_percent);
        } else if (type == "DISCOUNT PERCENT CHANGE" && discount_percent) {
          this.form.price_percent = 100 - parseInt(discount_percent);
        } else {
          this.form.price_percent = parseInt(price_percent)
            ? parseInt(price_percent)
            : 0;
          this.form.discount_percent = parseInt(discount_percent)
            ? parseInt(discount_percent)
            : 0;
          console.log("BLANK");
        }
        this.CalculateFinalAmount();
      }
      if (type == "FINAL AMOUNT CHANGE" || type == "DAY CHANGE") {
        this.CalculatePerDayAmount();
        this.CalculateCommission();
      }
      console.log(this.form);
      this.isCalculating = false;
    },
    CalculateSecondDiscountAmount() {
      let calculated_final_amount = this.form.calculated_final_amount;
      console.log(calculated_final_amount);

      let second_discount_amount = 0;
      // let final_discount_amount = 0;
      if (calculated_final_amount) {
        second_discount_amount =
          calculated_final_amount -
          parseInt(
            parseFloat(
              parseFloat(calculated_final_amount) *
                parseFloat(this.form.second_discount_percent)
            ) / 100
          );
      }
      console.log(second_discount_amount);
      this.form.second_discount_amount = second_discount_amount;
      this.form.final_amount =
        parseInt(calculated_final_amount) + parseInt(second_discount_amount);
      this.CalculateCommission();
    },
    CalculateFinalAmount() {
      let calculated_final_amount = 0;
      if (this.form.original_amount && this.form.price_percent) {
        calculated_final_amount =
          parseFloat(
            parseFloat(this.form.original_amount) *
              parseFloat(this.form.price_percent)
          ) / 100;
      }
      this.form.calculated_final_amount = calculated_final_amount;
    },
    CalculatePerDayAmount() {
      let customer_per_day_charges = 0;
      console.log(this.form.final_amount);
      console.log(this.form.days);

      if (this.form.final_amount && this.form.days) {
        customer_per_day_charges = Math.ceil(
          parseFloat(this.form.final_amount) / parseInt(this.form.days)
        );
        console.log(customer_per_day_charges);
      }
      this.form.customer_per_day_charges = customer_per_day_charges;
    },
    CalculateCommission(type = "") {
      let walkie_percent = parseFloat(this.form.walkie_percent) || 0;
      let franchisee_percent = parseFloat(this.form.franchisee_percent) || 0;
      let master_franchisee_percent =
        parseFloat(this.form.master_franchisee_percent) || 0;
      console.log("Calculate Commission : " + type);

      // Walkie (company) share is whatever remains after Walker, Franchisee and Master Franchisee
      let company_percent =
        100 - walkie_percent - franchisee_percent - master_franchisee_percent;
      if (company_percent < 0) company_percent = 0;

      this.$set(this.form, "walkie_percent", walkie_percent);
      this.$set(this.form, "franchisee_percent", franchisee_percent);
      this.$set(this.form, "master_franchisee_percent", master_franchisee_percent);
      this.$set(this.form, "company_percent", company_percent);
      this.CalculateWalkieAmount();
      this.CalculateFranchiseeAmount();
      this.CalculateMasterFranchiseeAmount();
      this.CalculateCompanyAmount();
    },
    CalculateMasterFranchiseeAmount() {
      let master_franchisee_commission_amount = 0;
      if (this.form.final_amount) {
        master_franchisee_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.master_franchisee_percent || 0)
          ) / 100
        );
      }
      this.$set(
        this.form,
        "master_franchisee_commission_amount",
        master_franchisee_commission_amount
      );
    },
    CalculateWalkieAmount() {
      let walkie_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        walkie_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.walkie_percent)
          ) / 100
        );
        console.log("Walkie Amount Updated : " + walkie_commission_amount);
      }
      this.form.walkie_commission_amount = walkie_commission_amount;
    },
    CalculateFranchiseeAmount() {
      let franchisee_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        franchisee_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.franchisee_percent)
          ) / 100
        );
        console.log(
          "Franchisee Amount Updated : " + franchisee_commission_amount
        );
      }
      this.form.franchisee_commission_amount = franchisee_commission_amount;
    },
    CalculateCompanyAmount() {
      let company_commission_amount = 0;
      console.log(this.form.final_amount);
      if (this.form.final_amount) {
        company_commission_amount = Math.ceil(
          parseFloat(
            parseFloat(this.form.final_amount) *
              parseFloat(this.form.company_percent)
          ) / 100
        );
        console.log("Company Amount Updated : " + company_commission_amount);
      }
      this.form.company_commission_amount = company_commission_amount;
    },
    Add_Empty_Benefit() {
      if (!Array.isArray(this.form.benefits)) {
        this.$set(this.form, "benefits", []);
      }
      this.form.benefits.push("");
    },
    Remove_Benefit(index) {
      this.form.benefits.splice(index, 1);
    },
    updateBenefit(index, value) {
      this.$set(this.form.benefits, index, value);
    },
    cleanBenefits() {
      let benefits = Array.isArray(this.form.benefits)
        ? this.form.benefits
        : [];
      this.$set(
        this.form,
        "benefits",
        benefits
          .map((benefit) => (benefit ? String(benefit).trim() : ""))
          .filter((benefit) => benefit)
      );
    },
    async save() {
      try {
        this.isLoading = true;
        this.cleanBenefits();
        await axios
          .post("/plans", this.form)
          .then(async () => {
            await this.saveUserTimestamp(null, this.form);
            this.isLoading = false;
            this.$router.push("/plans");
          })
          .catch((error) => {
            console.error(error);
            this.isUnAuthorised();
          });
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
